import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PaymentProviderModel } from '../views/models/payment-provider.model';
import { environment } from '../../environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PaymentProviderService {

  payment: BehaviorSubject<PaymentProviderModel[]> = new BehaviorSubject<PaymentProviderModel[]>([]);

  constructor(private http: HttpClient) {
  }

  getPayment() {
    return new Promise((resolve, reject) => {
      this.http.get(environment.baseURL + '/v2/api/payment_providers').subscribe((resp: PaymentProviderModel[]) => {
        this.payment.next(resp);
        resolve(resp);
      }, err => {
        reject(err);
      });
    });
  }

  postPayment(data: PaymentProviderModel) {

    return new Promise((resolve, reject) => {
      this.http.post(environment.baseURL + '/v2/api/payment_providers', data).subscribe(resp => {
        resolve(resp);
      }, err => {
        reject(err);
      });
    });

  }



  deletePayment(id: number) {
    return new Promise((resolve, reject) => {
      this.http.delete(environment.baseURL + '/v2/api/payment_providers/' + id).subscribe((resp) => {
        this.getPayment();
        resolve(resp);
      }, err => {
        reject(err);
      });
    });
  }
}


